import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import { trackHelpCenterEmailOverPhoneClick } from "@faire/web-api/events/helpCenter/click/emailOverPhone";
import { isPhoneInBusinessHours } from "../../Phone/isPhoneInBusinessHours";
export var trackEmailUsClickWhenPhoneInBusinessHours = function trackEmailUsClickWhenPhoneInBusinessHours(issueType, hasPhoneAccess) {
  var _getRetailerToken, _getBrandToken;
  if (!isPhoneInBusinessHours() || !hasPhoneAccess) {
    return;
  }
  var retailerToken = (_getRetailerToken = getRetailerToken()) !== null && _getRetailerToken !== void 0 ? _getRetailerToken : "";
  var brandToken = (_getBrandToken = getBrandToken()) !== null && _getBrandToken !== void 0 ? _getBrandToken : "";
  trackHelpCenterEmailOverPhoneClick(retailerToken, brandToken, issueType);
};